module.exports = __webpack_public_path__ + "img/0_banner.370d2ef8.png";